import { Mutation, Query } from '@apollo/client/react/components';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import CheckIcon from '@mui/icons-material/Check';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React from 'react';
import {
  IS_BLACKLISTED_AUTHOR,
  UNBLACKLIST_AUTHOR,
} from '../../../helpers/graphql/blacklist';

class AuthorBlacklist extends React.Component {
  state = {
    reason: '',
    open: false,
    isOnlyCommentBlacklisted: false,
  };

  handleCheckboxChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleTextFieldChange = content => {
    this.setState({ reason: content.target.value });
  };

  handleClickOpen = () => {
    if (this.props.setListenClickAway) this.props.setListenClickAway(false);
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.props.setListenClickAway) this.props.setListenClickAway(true);
    this.setState({ open: false });
  };

  newNotification(notification) {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar(notification.message, { variant });
    }
  }

  render() {
    return (
      <div>
        <Query
          query={IS_BLACKLISTED_AUTHOR}
          variables={{
            author: this.props.author,
          }}
        >
          {({ data }) => {
            if (
              (data &&
                data.isBlacklistedAuthor &&
                data.isBlacklistedAuthor.isBlacklisted) ||
              (data &&
                data.isBlacklistedAuthor &&
                data.isBlacklistedAuthor.isOnlyCommentBlacklisted)
            ) {
              const { reason } = data.isBlacklistedAuthor;
              const { isOnlyCommentBlacklisted } = data.isBlacklistedAuthor;
              return (
                <Mutation
                  mutation={UNBLACKLIST_AUTHOR}
                  variables={{
                    author: this.props.author,
                  }}
                >
                  {(
                    unblacklistAuthor,
                    // eslint-disable-next-line no-shadow
                    data,
                  ) => {
                    if (
                      data &&
                      data.data &&
                      data.data.unblacklistAuthor &&
                      this.state.open === true
                    ) {
                      this.newNotification({
                        success: data.data.unblacklistAuthor.success,
                        message: data.data.unblacklistAuthor.message,
                      });
                      this.setState({ open: false });
                    }
                    return (
                      <>
                        <MenuItem onClick={this.handleClickOpen}>
                          <ListItemIcon>
                            <CheckIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Remove author from blacklist" />
                        </MenuItem>
                        <Dialog
                          open={this.state.open}
                          onClose={this.handleClose}
                          aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description"
                        >
                          <DialogTitle id="alert-dialog-title">
                            Remove author from blacklist?
                          </DialogTitle>
                          <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                              This author has been blacklisted for the following
                              reason:
                              <em>{` ${reason} `}</em>
                              {isOnlyCommentBlacklisted && (
                                <p>
                                  This author is currently only blacklisted for
                                  comments. To also blacklist this author for
                                  posts, remove the author from the blacklist
                                  and add him again.
                                </p>
                              )}
                            </DialogContentText>
                            <DialogContentText id="alert-dialog-description">
                              Are you sure that you want to remove this author
                              from the blacklist?
                            </DialogContentText>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={this.handleClose} color="primary">
                              Cancel
                            </Button>
                            <Button
                              onClick={unblacklistAuthor}
                              color="primary"
                              variant="contained"
                              autoFocus
                            >
                              Remove from blacklist
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </>
                    );
                  }}
                </Mutation>
              );
            }
            return <></>;
          }}
        </Query>
      </div>
    );
  }
}

AuthorBlacklist.propTypes = {
  author: PropTypes.string.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
};

export default withSnackbar(AuthorBlacklist);
